import { AddressJsonldAddressReadAddressWrite } from '@/api/generated';
import { useTranslation } from 'react-i18next';
import { formatPhoneNumber } from 'react-phone-number-input';

export const FormattedAddress = ({ address }: { address: AddressJsonldAddressReadAddressWrite }) => {
  const { i18n } = useTranslation();

  const formatCountryCode = (countryCode: string | null | undefined) => {
    if (!countryCode) {
      return '';
    }

    const regionInLocale = new Intl.DisplayNames([i18n.language], { type: 'region' });

    return regionInLocale.of(countryCode) || countryCode;
  };

  const formattedPhone = formatPhoneNumber(address.phone || '');
  const additionalAddress = address.additionalAddress?.trim();

  return (
    <>
      {`${address.lastName} ${address.firstName}`}
      <br />
      <strong>
        {`${address.street}, ${address.zipCode} ${address.city}${address.region ? `, ${address.region}` : ''}, ${formatCountryCode(address.countryCode)}`}
      </strong>
      {additionalAddress && (
        <>
          <br />
          {additionalAddress}
        </>
      )}
      {formattedPhone && (
        <>
          <br />
          {formattedPhone}
        </>
      )}
    </>
  );
};
